/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const mobileOrderItemPaidBySchema = z
	.object({
		user_id: z.string(),
		name: z.string(),
	})
	.describe("Информация о пользователе, оплатившем позицию.");
